import React from "react";
import { LAYERS } from "../app/tokens.js";
import "./objectChrome.css";

// Records own their identity and controls; shared chrome owns the outer bands.
// Collection/Home's responsive page spacing belongs to the scrolling entry,
// never to the title, navigation or an enclosing shell wrapper.
export function DetailRecordHeader({ children, headerSearch, headerRightSlot, actions, searchOpen, titleVariant = "two-line", style, ...props }) {
  return (
    <header {...props} className={`v2-detail-header v2-chrome-strip object-title-row object-title-${titleVariant} object-detail-header${searchOpen ? " is-search-open" : ""}`}
      style={{ ...style, zIndex: searchOpen ? LAYERS.modal : LAYERS.stickyChrome }}>
      {children}
      {headerSearch}
      {(actions || headerRightSlot) && <div className="v2-detail-controls object-detail-controls">
        {actions && <div className="object-detail-actions">{actions}</div>}
        {headerRightSlot}
      </div>}
    </header>
  );
}

export function DetailNavBand({ children, enabled = true, className = "", ...props }) {
  return <div {...props} className={`${enabled ? "object-subnav-row object-detail-nav " : ""}${className}`.trim()}>{children}</div>;
}
